export const createRowEntity = (Entity, entityData, rowData) => class extends Entity {
  disabled = false;

  expanded = false;

  highlighted = false;

  subheader = false;

  selected = false;

  mountKey = 1;

  constructor () {
    super(entityData);

    if (rowData) {
      if (rowData.expanded) this.expanded = rowData.expanded;
      if (rowData.disabled) this.disabled = rowData.disabled;
      if (rowData.highlighted) this.highlighted = rowData.highlighted;
      if (rowData.subheader) this.subheader = rowData.subheader;
      if (rowData.mountKey) this.mountKey = rowData.mountKey;
    }
  }

  get isExpanded () {
    return this.expanded;
  }

  get isDisabled () {
    return this.disabled;
  }

  get isHighlighted () {
    return this.highlighted;
  }

  get isSubheader () {
    return this.subheader;
  }

  get updateKey () {
    return this.mountKey;
  }

  switchExpanded () {
    this.expanded = !this.expanded;
  }

  expand () {
    this.expanded = true;
  }

  downscale () {
    this.expanded = false;
  }

  disable () {
    this.disabled = true;
  }

  enable () {
    this.disabled = false;
  }

  highlight () {
    this.highlighted = true;
  }

  unhighlight () {
    this.highlighted = false;
  }
};
